import React, {
  createContext, useContext, useState, ReactNode,
} from 'react';
import { IWindRose } from 'src/typings/spinner';

interface WindRoseContextType {
  windRoseData: IWindRose | null;
  updateWindRoseData: (data: IWindRose | null) => void;
}

const WindRoseContext = createContext<WindRoseContextType | undefined>(undefined);

interface WindRoseProviderProps {
  children: ReactNode;
}

export const WindRoseProvider: React.FC<WindRoseProviderProps> = ({ children }) => {
  const [windRoseData, setWindRoseData] = useState<IWindRose | null>(null);

  const updateWindRoseData = (data: IWindRose | null) => {
    setWindRoseData(data);
  };

  return (
    <WindRoseContext.Provider value={{ windRoseData, updateWindRoseData }}>
      {children}
    </WindRoseContext.Provider>
  );
};

export const useWindRoseContext = () => {
  const context = useContext(WindRoseContext);
  if (context === undefined) {
    throw new Error('useWindRoseContext must be used within a WindRoseProvider');
  }
  return context;
};
